import { jsxs as d, jsx as i } from "react/jsx-runtime";
import c from "xss";
const u = ["http:", "https:", "mailto:", "tel:"];
function f(r) {
  if (!r)
    return "";
  const t = r.trim();
  if (!t)
    return "";
  try {
    const s = t.startsWith("//") ? `https:${t}` : t, o = new URL(s, "https://placeholder.invalid");
    if (!u.includes(o.protocol))
      return "";
  } catch {
    return t.startsWith("/") || t.startsWith(".") ? t : "";
  }
  return t;
}
const v = ({
  posterUrl: r,
  isLoading: t,
  isVisible: s,
  onActivate: o,
  instanceLabel: a,
  errorMessage: l,
  previewOnly: e = !1
}) => /* @__PURE__ */ d(
  "button",
  {
    type: "button",
    className: `video-poster ${s ? "" : "is-hidden"} ${t ? "is-loading" : ""} ${e ? "video-poster--preview" : ""}`,
    onClick: e ? void 0 : o,
    onKeyDown: (n) => {
      e || (n.key === "Enter" || n.key === " ") && (n.preventDefault(), o());
    },
    "aria-label": e ? "Preview only" : `Play video: ${a}`,
    title: e ? "Preview Only" : void 0,
    disabled: t || e,
    children: [
      /* @__PURE__ */ i("img", { src: f(c(r)), alt: "Video poster" }),
      s && (t ? /* @__PURE__ */ i("div", { className: "play-loader" }) : /* @__PURE__ */ i("div", { className: "play-icon u-flex u-flexAlignItemsCenter u-flexJustifyCenter" })),
      l && /* @__PURE__ */ i("div", { className: "video-error-message", children: l })
    ]
  }
);
export {
  v as VideoPoster
};
//# sourceMappingURL=VideoPoster.mjs.map
